import usePageData from '@/composables/usePageData';
/** @import { IKillSwitch } from '@/types/definitions'; */
/**
 * Composable for getting the killswitch properties
 * IMPORTANT : MUST ADD ALL USED VALUES TO constants.js ANY VALUES NOT INCLUDED
 * IN THAT FILE WILL BE FILTERED OUT IN cachedFilteredProperties()
 * @returns {IKillSwitch} - Returns a KillSwitch object
 */
export default function useKillSwitches() {
  const pageData = usePageData();
  const properties = pageData?.value?.meta?.properties || {};
  const {
    sitemonGAMTagsInSSREnabled = false,
    isRoktSDKPlusEnabled = false,
    isAskAIOverviewAnalyticsEnabled = false,
    isBigTicketCXSearchAndBrowseTypeEnabled = false,
    isSiteMonHeartFunctionalityEnabled = false,
    uniqueSearchPatternEnabled = false,
    pzoBadgingEnabled = false,
    scrollyCatsEnabled = false,
    priceSimplificationEnabled = false,
    newBreadcrumbStructureEnabled = false,
    loyaltyBadgeEnhancementEnabled = false,
    enableH3ProductTitlesSortableGrid = false,
    discoveryGridQuickShopEnabled = false,
    newGoogleAPICallEnabled = false,
    newPlacesDetailsApiEnabled = true,
    storeInPreferenceDatabaseEnabled = false,
    secondRowBadgeEnabled = false,
    valueGiftBadgeEnabled = false,
    disableSplashLeftHandNavigation = false,
    altGridViewEnabled = false,
    isLazyHydrationProductThumbnailEnabled = false,
    isPTMewQuickViewEnabled = false,
    grayProductImageBgEnabled = false,
    aiOverviewEnabled = false,
    getItTodayEnabled = false,
    isAIWaterMarkEnabled = false,
    badgeRedesignEnabled = false,
    oneClickSaleEnabled = false,
    plpMasterFlag = false,
    uiEmbeddedStarMoneyEnabled = true,
    uiBrowseCompareToolEnabled = true,
    uiBrowseBcomV3StickyFilterEnabled = true,
    isPTMewQuickViewOverrideEnabled1 = false,
    isPTMewQuickViewOverrideEnabled2 = false,
  } = properties;
  /* IMPORTANT: NEW VALUE? SEE TOP OF FILE */

  return {
    sitemonGAMTagsInSSREnabled,
    isRoktSDKPlusEnabled,
    isAskAIOverviewAnalyticsEnabled,
    isBigTicketCXSearchAndBrowseTypeEnabled,
    isSiteMonHeartFunctionalityEnabled,
    uniqueSearchPatternEnabled,
    pzoBadgingEnabled,
    scrollyCatsEnabled,
    priceSimplificationEnabled,
    newBreadcrumbStructureEnabled,
    loyaltyBadgeEnhancementEnabled,
    enableH3ProductTitlesSortableGrid,
    discoveryGridQuickShopEnabled,
    newGoogleAPICallEnabled,
    newPlacesDetailsApiEnabled,
    storeInPreferenceDatabaseEnabled,
    secondRowBadgeEnabled,
    valueGiftBadgeEnabled,
    disableSplashLeftHandNavigation,
    altGridViewEnabled,
    isLazyHydrationProductThumbnailEnabled,
    isPTMewQuickViewEnabled,
    grayProductImageBgEnabled,
    aiOverviewEnabled,
    getItTodayEnabled,
    isAIWaterMarkEnabled,
    badgeRedesignEnabled,
    oneClickSaleEnabled,
    plpMasterFlag,
    uiEmbeddedStarMoneyEnabled,
    uiBrowseCompareToolEnabled,
    uiBrowseBcomV3StickyFilterEnabled,
    isPTMewQuickViewOverrideEnabled1,
    isPTMewQuickViewOverrideEnabled2,
  };
}
